import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util.js";

export var TriggerTester = function(component) {
    this.component = component;
    this.$sfmc = flywhweelSFMCUtilFactory(component, "sfmc");
};
Object.assign(
    TriggerTester,
    {
        PROCESS_STATES: {
            IDLE: "Idle",
            QUEUED: "Queued...",
            TESTING: "Testing...",
            ERROR: "ERROR",
            DONE: "Done."
        }
    }
);
Object.assign(
    TriggerTester.prototype,
    {
        test: function(data, processStatus, form) {
            var attributes = [];
            data.dataExtension.forEach((field) => {
                if (
                    (!field["template_field"]) &&
                    (!field["default_value"].length)
                ) {
                    attributes.push({
                        "Name": field["field_name"],
                        "Value": (
                            field["sample_value"].length ?
                            field["sample_value"] :
                            `[${field["field_name"]}]`
                        )
                    });
                }
            });
            processStatus.state = TriggerTester.PROCESS_STATES.TESTING;
            return this.$sfmc.apiCall(
                "create",
                {
                    "object_type": "TriggeredSend",
                    "properties": {
                        "TriggeredSendDefinition": {
                            "CustomerKey": data.properties["trigger_properties"]["external_key"]
                        },
                        "Subscribers": {
                            "EmailAddress": form.testEmailAddress,
                            "SubscriberKey": form.testSubscriberKey,
                            "Attributes": attributes
                        }
                    }
                }
            );
        }
    }
)
export default function(component) {
    return new TriggerTester(component);
}